import { ArrowDownDark } from '@icons';

const FileUploadButton = ({ htmlKey, setterFn }: { htmlKey: string; setterFn: (arg: File) => void }) => (
	<>
		<label
			htmlFor={`file-upload-${htmlKey}`}
			style={{
				cursor: 'pointer',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '12px 16px',
				borderRadius: 8,
				backgroundColor: 'var(--np-primary-color)',
				color: 'white',
				width: 'fit-content',
				fontWeight: 500,
				gap: 8,
			}}
		>
			<ArrowDownDark style={{ fill: 'white', transform: 'rotate(180deg)' }} />
			CARICA FILE
		</label>
		<input
			id={`file-upload-${htmlKey}`}
			type="file"
			style={{ display: 'none' }}
			onChange={(e) => e.target.files.length && setterFn(e.target.files[0])}
		/>
	</>
);

export default FileUploadButton;
